import FeaturesSection from "../components/views/users/features/FeaturesSection";
import Hero from "../components/views/users/features/Hero";
import FAQ from "../components/views/users/home/Faq";
import GetStarted from "../components/views/users/home/GetStarted";

const Features = () => {
  return (
    <div>
      <Hero />
      <FeaturesSection />
      <FAQ />
      <GetStarted />
    </div>
  );
};

export default Features;
